import { render, staticRenderFns } from "./CountryInfo.vue?vue&type=template&id=1200f0d0&scoped=true&"
import script from "./CountryInfo.vue?vue&type=script&lang=js&"
export * from "./CountryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1200f0d0",
  null
  
)

export default component.exports